// export const SERVER_URL = "http://localhost/crm_1/crm";
 export const SERVER_URL = "https://sbefintech.co.in/ProcessAutomation";